import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import ActivitiesViewPage from '@/areas/manufacturing-templates/Activities/ActivitiesView/ActivitiesViewPage';
import { canViewManufacturing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/manufacturing/_sidebar/activities/')({
    staticData: { access: { permissions: canViewManufacturing }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ActivitiesViewPage />;
}
